export const INVISIBLE_TEXT_CHAR = "\u200B";

export function toStoredEditableText(value) {
  if (typeof value !== "string") {
    return value;
  }

  return value === "" ? INVISIBLE_TEXT_CHAR : value;
}

export function fromStoredEditableText(value) {
  if (typeof value !== "string") {
    return value ?? "";
  }

  return value === INVISIBLE_TEXT_CHAR ? "" : value;
}

export function normalizeEditableRecord(record) {
  if (!record || typeof record !== "object" || Array.isArray(record)) {
    return record;
  }

  let changed = false;
  const normalized = {};

  Object.entries(record).forEach(([key, value]) => {
    const normalizedValue = toStoredEditableText(value);
    normalized[key] = normalizedValue;
    if (normalizedValue !== value) {
      changed = true;
    }
  });

  return changed ? normalized : record;
}
